const performAuthRedirect = (state, loginHint) => {
    const redirectUrl = new URL(window.location.origin);
    redirectUrl.pathname = `/login/callback/${state}`;
    const authUrl = new URL(window.RG_CONFIG.AUTH_URL);
    authUrl.pathname = '/v2/login';
    authUrl.searchParams.append('redirect_uri', redirectUrl.href);
    if (loginHint.length)
        authUrl.searchParams.append('login_hint', loginHint);
    window.location = authUrl.href;
};
export default performAuthRedirect;
